import React, { Component } from "react";

class CobrandSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.getCobrandId(),
			cobrands: this.getCobrands()
		}
		this.handleChange = this.handleChange.bind(this);
	}

	getCobrandId() {
		return localStorage.getItem("cobrandId");
	}

	getCobrands() {
		var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands ? JSON.parse(localStorage.getItem("userData")).cobrands : [];
		return cobrands;
	}

	getRedirectURL(currentURL, newCobrandId) {
		var redirectURL = "/";
		if (currentURL.includes("applications")) {
			redirectURL = "/applications/"+newCobrandId;
		} else if (currentURL.includes("reports")) {
			redirectURL = "/reports/"+newCobrandId;
		} else if (currentURL.includes("config")) {
			redirectURL = "/config/"+newCobrandId;
		} else if (currentURL.includes("webhooks")) {
			redirectURL = "/webhooks/"+newCobrandId;
		} else if (currentURL.includes("userMgmt")) {
			redirectURL = "/userMgmt/"+newCobrandId;
		}
		return redirectURL;
	}

	handleChange(event) {
		this.setState({value: event.target.value});
		this.setAndRedirect(event.target.value);
	}

	setAndRedirect(cobrandId) {
		localStorage.setItem("cobrandId", cobrandId);
		var redirectURL = this.getRedirectURL(window.location.href, cobrandId);
		window.location.href = redirectURL;
	}

	render() {
		return (
			<React.Fragment>
				{
					this.state.cobrands.length > 1 ? (
						<select className="custom-select" value={this.state.value} onChange={this.handleChange}>
						{
							this.state.cobrands.map((cobrand, key) =>
								<option key={cobrand.id} value={cobrand.id}>{cobrand.name} - {cobrand.id}</option>
							)
						}
					</select>
					) : (
						<div className="section-header text-right mt-2">{this.state.cobrands[0].name} - {this.state.cobrands[0].id}</div>
					)
				}
			</React.Fragment>
		);
	}

}

export default CobrandSelector;